module.exports = __webpack_public_path__ + "img/emoji-2.678a0545.png";